import React, { ReactNode } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { TooltipPlacement } from 'antd/es/tooltip';
import StyledCustomButton from './CustomButton.styles';
import CustomToolTip from '../customPopover';

interface CustomButtonProps {
  title?: string | ReactNode;
  type?: 'primary' | undefined | 'dashed' | 'link' | 'text' | 'default';
  size?: 'large' | 'middle' | 'small';
  icon?: ReactNode;
  disabled?: boolean;
  shape?: 'default' | 'circle' | 'round';
  block?: boolean;
  danger?: boolean;
  ghost?: boolean;
  onlyIcon?: boolean;
  href?: string;
  loading?: boolean | { delay: number };
  onClick?: () => void;
  ClassName?: string;
  dataTestId?: string;
  style?: object;
  tooltipText?: unknown;
  tooltipColor?: string;
  placement?: TooltipPlacement;
  noborder?: boolean;
  id?: string;
  tooltipClassName?: string;
  active?: boolean;
  defaultMode?: boolean;
  overlayInnerStyle?: object;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  title,
  type,
  size,
  onlyIcon,
  icon = onlyIcon && <QuestionCircleOutlined />,
  disabled,
  shape,
  block,
  danger,
  ghost,
  loading,
  ClassName,
  onClick,
  href,
  dataTestId,
  style,
  tooltipText,
  tooltipColor,
  placement,
  noborder = true,
  id,
  tooltipClassName,
  active = false,
  defaultMode,
  overlayInnerStyle,
}) => (
  <CustomToolTip
    title={tooltipText as string}
    color={tooltipColor}
    placement={placement}
    overlayClassName={tooltipClassName}
    overlayInnerStyle={overlayInnerStyle}
  >
    <StyledCustomButton
      type={type || 'default'}
      active={active}
      shape={shape || 'default'}
      size={size || 'large'}
      icon={icon}
      disabled={disabled}
      block={block}
      danger={danger}
      ghost={ghost}
      loading={loading}
      href={href}
      onClick={onClick}
      className={ClassName}
      data-testid={dataTestId || 'customButton'}
      style={style}
      noborder={noborder}
      defaultMode={defaultMode}
      {...{ id }}
    >
      {onlyIcon ? '' : title || 'unknown'}
    </StyledCustomButton>
  </CustomToolTip>
);

export default CustomButton;
